export default {
    header: {
        products: 'Товары для дома',
        vg: 'Обучение по видео',
        download: 'загрузк',
        about: 'О компании'
    },
    pageTitle1: 'Сделайте ваш телевизор',
    pageTitle2: 'умнее',
    available: 'Скоро',
    buy: 'купить',
    config: 'Конфигурация',
    os: {
        title: "Больше вариантов игры, улучшенный опыт",
        intro: "Экосистема AuroraTV, включающая AuroraOS, разработана на базе Slimbox с тщательной оптимизацией сетевых функций системы  скорости работы. Легковесная архитектура обеспечивает плавный интерактивный опыт!"
    },
    comment: {
        title: 'Отзывы покупателей',
        Subtitle: 'Что говорят наши клиенты',
        text: 'Реальные отзывы покупателей, чтобы помочь вам сделать уверенный выбор.'
    },
    certificate: {
        title: 'Познакомьтесь с AURORA',
        text: 'Интеллектуальная система AURORA — это не только плавный интерфейс и персонализированное управление, но также широкий выбор приложений, удобное дистанционное управление и стабильная работа, превращающие телевизор в полноценный центр развлечений.'
    },
    aurora: {
        title: 'Экосистема приложений AURORA',
        mcplayer: 'MCPlayer — это медиаплеер с трансляциями спортивных событий в реальном времени, подписками на фильмы и сериалы, а также поддержкой телеканалов. Доступные каналы и контент могут отличаться в зависимости от страны или региона.',
        mcstore: 'McStore — это магазин приложений для Android TV, предлагающий лицензионные приложения, игры и видеосервисы для смарт-телевизоров!'
    },
    osIntro: 'Какие новые функции предлагает AURORATV OS по сравнению с другими прошивками на рынке?',
    osTitle: 'Больше',
    osSecTitle: 'Дополнительные возможности',
    extended: {
        remote: 'Самоопределение ключа быстрого действия',
        timezone: 'Решение проблем с часовым поясом',
        clean: 'Очистка памяти в один клик',
        intro1: 'Настройте функции кнопок пульта для совместимости с различными устройствами и интеграции с новейшей системой AURORA, обеспечивая быстрое управление и запуск приложений одним нажатием.',
        intro2: 'Всего одним кликом легко очистите кеш телевизора, чтобы повысить производительность, обеспечить более плавную работу и поддерживать оптимальную эффективность устройства.',
        intro3: 'При ограничениях сети или сбоях сервера NTP, которые вызывают проблемы с подключением, мгновенно переключитесь на другой сервер NTP, чтобы быстро восстановить синхронизацию времени.'
    },
    equipped: {
        title: 'Поддерживаемые модели',
        buy: 'Купить',
        productParame: 'Характеристики',
        tanix: {
            param1: 'Процессор: Amlogic S905W2',
            param2: 'Память: 4+32GB/4+64GB',
            param3: 'ОС: Android 11.0'
        },
        x96q: {
            param1: 'Процессор: Allwinner H313',
            param2: 'Память: 2+16GB',
            param3: 'ОС: Android 10.0',
        },
        aurora: {
            param1: 'Процессор: Amlogic S905W2',
            param2: 'Память: 4+32GB/4+64GB',
            param3: 'ОС: Android 11.0'
        },
        elite: {
            param1: 'Процессор: Quad Core ARM Cortex A53',
            param2: 'Память: 2+16GB',
            param3: 'ОС: Android 10.0'
        }
    },
    remote: {
        intro: 'Управляйте телевизором с телефона в любое время и в любом месте - легкая и естественная жизнь у вас под рукой!',
        download: 'Скачать сейчас',
        note: 'В настоящее время поддерживаются только',
        andriod: 'телефоны Android',
        open_intro: 'Легко управляйте приложениями на ТВ с телефона - мгновенно запускайте любимые приложения одним касанием. Поддержка пользовательской сортировки и закрепления часто используемых приложений для плавной работы.',
        ipt_intro: 'Теперь вы можете вводить текст на ТВ без утомительных нажатий - просто наберите текст в приложении и отправьте прямо на телевизор.',
        file_intro: 'Загружайте APK-файлы прямо на телевизор для установки приложений - намного быстрее и удобнее, чем через USB!',
        ctl_intro: 'Приложение Aurora Remote позволяет управлять вашим Android-телевизором без физического пульта.',
        fbTitle: 'Возьмите телефон',
        fbSecTitle: 'Откройте приложение для управления в любое время',
        fbIntro: 'Работает со всеми моделями - просто откройте приложение, подключитесь к устройству и начинайте управление',
        more: 'Дополнительные функции'
    },
    application: {
        title: 'Собственное приложение, все о соревнованиях здесь',
        mcstore: {
            appName: 'MCStore',
            appDesc: 'Предоставляем более сотни надежных ибезопасных телевизионных приложений для простого и быстрого скачивания ииспользования.'
        },
        mcplayer: {
            appName: 'MCPlayer',
            appDesc: 'Доступ по подписке к 20000 каналам, 100000 фильмов и сериалов, включая 3000 спортивных каналов.'
        }
    },
    feature: {
        specification: 'Спецификация',
        product: 'продукта',
        x96q: {
            f: "Производительное ядро, мгновенный отклик",
            s: "Совместимость со всеми устройствами",
        },
        aurora: {
            f: "Четырёхъядерная архитектура A35",
            s: "Двухдиапазонный Wi-Fi 5"
        },
        tanix: {
            f: "Пользовательская прошивка Slimbox+",
            s: "Бесшумная система охлаждения"
        }
    },
    userComment: [{
            content: 'уже вторая покупка такой приставки, работает нормально, подключиося к интернету быстро просто, всё пока устраивает, замечаний нет! '
        },
        {
            content: 'отлично! в коробке всё работает "из коробки"! есть и тв каналы и фильмы! всё работает без тормозов и глюков '
        },
        {
            content: 'Отличное качество, все работает без проблем Очень нравится, приложения устанавливаются без проблем '
        },
        {
            content: 'отличная приставка,гораздо лучше которой пользовался раньше,качественная картинка,шустро работает.В настройке без проблем. ',
        },
        {
            content: 'Покупкой доволен, клиенты тоже. Кому что нужно, то и устанавливаю, имею ввиду прошивки. Общем люди довольны и я не в накладе. ',
        },
        {
            content: 'Я знал, что покупаю - это на сегодня самый лучший по соотношению цена/качество ТВ-бокс!К приобретению могу смело советовать! ',
        }
    ],
    videoGuidece: 'Операции и ответы на вопросы',
    videoTitle: 'Обучающее видео',
    videoIntroduction1: 'Видео по прошивке Tanix W2',
    videoIntroduction2: 'Обучающее видео по приложению MCPlayer',
    videoIntroduction3: 'Инструкция по сопряжению Bluetooth-пульта',
    dowmloadRemote: {
        mainDesc: 'Совместимо со всеми TV-приставками Aurora на системе SlimBOX+. Используйте приложение Aurora Remote для удобного управления телевизором со смартфона! Просто подключите ваш Smart TV и Aurora Remote к одной сети WiFi или выполните сопряжение по Bluetooth, чтобы включать/выключать телевизор, запускать приложения одним нажатием, регулировать громкость и устанавливать приложения!',
        dowmload: 'Скачать приложение',
        text1: 'В настоящее время только для',
        text2: 'Android-смартфонов',
        text3: 'версия',
        title: 'Пульт AURORA для ТВ',
        secondary_title: 'Удобное управление телевизором с расширенными возможностями',
        quick_title: 'Быстрый запуск',
        quick_title_sec: 'Приложений',
        quick_open_txt: 'Система автоматически сканирует все установленные приложения на телевизоре с возможностью персонализированной сортировки. Просто перетаскивайте любимые приложения вверх для создания быстрого доступа и запуска в одно касание.',
        file_title: 'Файловая',
        file_secondary_title: 'передача',
        file_txt: 'Без USB! Функция загрузки файлов в Aurora Remote позволяет передавать APK-файлы на TV-приставку для установки приложений.',
        media_title: 'Реагирующая',
        media_secondary_title: 'сенсорная панель',
        media_txt: 'Навигация с помощью кнопок направления или сенсорного управления, как с физическим пультом!',
        search_title: 'Быстрый',
        search_secondary_title: 'ввод и поиск',
        search_txt: 'Поддержка быстрого ввода текста и поиска для более эффективной работы с телевизором.'
    },
    dowmloadMcstore: {
        mainDesc: 'Собственная платформа магазина приложений от AURORA. Мы предлагаем более сотни надежных и безопасных приложений для телевизоров, чтобы вы могли легко и быстро их скачивать и использовать.',
        dowmload: 'Скачать приложение',
        text1: 'Это приложение доступно только для',
        text2: 'Andriod TV'
    },
    about: {
        headHL: 'Здравствуйте!',
        headSub: 'Мы — AURORA',
        outTitle1: 'Что такое AURORA?',
        outIntro1: 'AURORA — это IT-компания и креативная лаборатория, оснащенная передовым производственным оборудованием, активным сообществом, динамичной творческой энергией и культурой, где каждый чувствует свою ценность. С 2024 года мы создаем технологии, умные устройства и удобные сервисы для людей. Гарантия качества',
        outTitle2: 'Гарантия качества',
        outIntro2: 'Вся работа начинается с исследований. На их основе мы проводим многомерную концептуальную проработку, итерации прототипов, построение аппаратной архитектуры и проверку дизайна. В процессе мы привлекаем экспертов отрасли, устанавливаем сотрудничество с научными учреждениями и проводим системные испытания на профессиональном оборудовании. Потребности будущих пользователей остаются в центре внимания на всех этапах разработки устройств, сервисов и технологий.',
        outTitle3: 'Сервисная гарантия',
        outIntro3: 'Все ТВ-приставки AURORA являются оригинальными продуктами. От разработки и производства до продаж они проходят строгий контроль качества, каждая единица проверяется в несколько этапов, чтобы гарантировать превосходное качество и стабильную работу, обеспечивая надежность и комфорт при использовании.',
        outTitle4: 'Инвесторам',
        outIntro4Part1: 'По вопросам, связанным с инвестициями, пишите на ',
        outIntro4Part2: ' или свяжитесь через Telegram/WhatsApp.',
        outTitle5: 'Частным клиентам',
        outIntro5Part1: 'По общим вопросам, включая индивидуальные и оптовые заказы, цены, логистику, оплату, доставку и возврат, обращайтесь в ',
        outIntro5Part2: 'официальный магазин OZON',
        outIntro5Part3: '.',
        contactHL: 'Сотрудничество',
        contactSub: 'Контакты'
    },
    footer: {
        serverTitle: 'Часы консультаций:',
        serverTime: 'Понедельник-пятница с 9:00 до 12:00 и с 14:00 до 19:00, кроме государственных праздников'
    }
}